import { customElement, state } from 'lit/decorators.js';
import { TeTableRow } from './te-table-row';

/** Table Column Component */
@customElement('te-table-column')
export class TeTableColumn extends TeTableRow {
  @state() spacingDirection: 'x' | 'y' = 'y';
  @state() containerClass: 'te-table-row' | 'te-table-column' = 'te-table-column';
}

declare global {
  interface HTMLElementTagNameMap {
    'te-table-column': TeTableColumn;
  }
}
